var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class DigitalProjection {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.legacyApi = true;
        this.powerOnStatus = ['2', '4', '5'];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*blanking.enable ?`, /(OFF|ON)|NACK|NAK/i, tags);
                    return match[1] ? match[1] === 'ON' : this.state.displayBlank.value;
                }
                else {
                    const match = yield this.socket.send(`op blank ?`, /OP\s+BLANK\s*=\s*(0|1)|NACK|NAK/i, tags);
                    return match[1] ? match[1] === '1' : this.state.displayBlank.value;
                }
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*blanking.enable = ${blank ? 'ON' : 'OFF'}`, /ACK\s+blanking.enable\s+=\s+(OFF|ON)|NACK|NAK/i, tags);
                    return match[1] ? match[1] === 'ON' : this.state.displayBlank.value;
                }
                else {
                    const match = yield this.socket.send(`op blank = ${blank ? '1' : '0'}`, /op\s+blank\s*=\s*(0|1|OFF|ON)|NACK|NAK/i, tags);
                    return match[1]
                        ? match[1] === '1' || match[1].toUpperCase() === 'ON'
                        : this.state.displayBlank.value;
                }
            }),
            powerOffRestrictions: ['get', 'set'],
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    if (this.legacyApi) {
                        const match = yield this.socket.send(`*blanking.enable?`, /ACK\s+blanking.enable\s*=\s*(OFF|ON)|NACK|NAK/i, ['hasControl.blank'], { sendTimeoutMs: 1000 });
                        return match[1] !== undefined;
                    }
                    else {
                        const match = yield this.socket.send(`op blank ?`, /op\s+blank\s*=\s*(\d+)|illegal format/i, ['hasControl.blank'], { sendTimeoutMs: 1000 });
                        return match[1] !== undefined;
                    }
                }
                catch (err) {
                    return false;
                }
            }),
        };
        this.displayFreeze = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*freeze ?`, /(OFF|ON)/i, tags);
                    return match[1] === 'ON';
                }
                else {
                    const match = yield this.socket.send(`op freeze ?`, /op\s+freeze\s*=\s*(0|1|OFF|ON)/i, tags);
                    return match[1].toUpperCase() === 'ON' || match[1] === '1';
                }
            }),
            set: (freeze, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*freeze = ${freeze ? 'ON' : 'OFF'}`, /ACK\s+freeze\s+=\s+(OFF|ON)|NACK|NAK/i, tags);
                    return match[1] ? match[1] === 'ON' : this.state.displayFreeze.value;
                }
                else {
                    const match = yield this.socket.send(`op freeze = ${freeze ? 1 : 0}`, /op\s+freeze\s*=\s*(0|1|OFF|ON)|NACK|NAK/i, tags);
                    return match[1]
                        ? match[1] === '1' || match[1].toUpperCase() === 'ON'
                        : this.state.displayFreeze.value;
                }
            }),
            powerOffRestrictions: ['get', 'set'],
            hasControl: () => __awaiter(this, void 0, void 0, function* () {
                try {
                    if (this.legacyApi) {
                        const match = yield this.socket.send(`*freeze ?`, /ACK\s+freeze\s+=\s+(OFF|ON)|NACK|NAK/i, ['hasControl.freeze'], { sendTimeoutMs: 1000 });
                        return match[1] !== undefined;
                    }
                    else {
                        const match = yield this.socket.send(`op freeze ?`, /op\s+freeze\s*=\s*(\d+)|illegal format/i, ['hasControl.freeze'], { sendTimeoutMs: 1000 });
                        return match[1] !== undefined;
                    }
                }
                catch (err) {
                    return false;
                }
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*sw.version ?`, /(?:ack\s*sw\.version\s*=)?\s*(.+)/i, tags);
                    return match[1];
                }
                else {
                    const match = yield this.socket.send(`op sw.ver ?`, /op\s+sw.ver\s*=\s*(.+)/i, tags);
                    return match[1];
                }
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*power ?`, /(0|1|OFF|ON)/i, tags);
                    return match[1] === 'ON' || match[1] === '1';
                }
                else {
                    const match = yield this.socket.send(`op status?\rop status ?`, /op\s+status\s*=\s*(\d)/i, tags);
                    return this.powerOnStatus.includes(match[1]);
                }
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    let match = yield this.socket.send(`*power = ${power ? 'ON' : 'OFF'}`, /N?ACK\s+power\s+=\s+(0|1|OFF|ON|NA)/i, tags);
                    if (match[1].toUpperCase() === 'NA') {
                        // Send command using 1 and 0
                        match = yield this.socket.send(`*power = ${power ? '1' : '0'}`, /N?ACK\s+power\s+=\s+(0|1|OFF|ON|NA)/i, tags);
                    }
                    // Field testing shows that the projector takes about 18 seconds to report it is
                    // powered on. See SNTY-3238.
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), power ? 22000 : 2000);
                    return match[1] ? match[1] === '1' || match[1] === 'ON' : this.state.power.value;
                }
                else {
                    const match = yield this.socket.send(`op power.${power ? 'on' : 'off'}`, /op\s+power[\.\s]?(off|on)|illegal format/i, tags);
                    if (match[1]) {
                        // Field testing shows that the projector takes about 18 seconds to report it is
                        // powered on. See SNTY-3238.
                        this.state.busy.update(true);
                        this.busyTimeout.set(() => this.state.busy.update(false), power ? 22000 : 2000);
                        this.framework.suspend(power ? 22000 : 2000);
                        return match[1].toUpperCase() === 'ON';
                    }
                    return this.state.power.value;
                }
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*input ?`, /(\d+)/i, tags);
                    return match[1];
                }
                else {
                    const match = yield this.socket.send(`op input.sel ?`, /op\s+input\.sel\s*=\s*(\d+)/i, tags);
                    return match[1];
                }
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                if (this.legacyApi) {
                    const match = yield this.socket.send(`*input = ${code}`, /ACK\s+input\s+=\s+(\d+)|NACK|NAK/i, tags);
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                    return match[1] ? match[1] : this.state.videoInput.value;
                }
                else {
                    const match = yield this.socket.send(`op input.sel = ${code}`, /op\s+input\.sel\s*=\s*(\d+)|NACK|NAK/i, tags);
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                    return match[1] ? match[1] : this.state.videoInput.value;
                }
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 4000, controls: ['power', 'videoInput', 'displayBlank', 'displayFreeze'] },
        ];
    }
    // phase callbacks
    onBeforeConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            // If the model number changes in Mal, recompute legacyApi
            this.legacyApi =
                config.modelNumber !== '-N31OyYVbDKChnZIt2DN' && // E-9000 uses a newer API.
                    config.modelNumber !== '-NJN98tE0YKrBCbhIbtT'; // E-4000 uses a newer API
        });
    }
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials, config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.legacyApi =
                config.modelNumber !== '-N31OyYVbDKChnZIt2DN' && // E-9000 uses a newer API.
                    config.modelNumber !== '-NJN98tE0YKrBCbhIbtT'; // E-4000 uses a newer API
            const initializerSteps = this.legacyApi
                ? [
                    {
                        errorCode: 'verifyFailed',
                        send: `*power ?`,
                        succeed: /(0|1|OFF|ON)/i,
                        next: /illegal/i,
                    },
                ]
                : [
                    {
                        errorCode: 'verifyFailed',
                        send: `op status?\rop status ?`,
                        succeed: /op\s+status\s*=\s*(\d)/i,
                    },
                ];
            return CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
        });
    }
}
// static properties
DigitalProjection.driverType = 'socketDriver';
DigitalProjection.key = '-N30OlyFFprpetBntqQN';
DigitalProjection.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
};
DigitalProjection.socketOptions = [
    Object.assign(Object.assign({}, DigitalProjection.baseSocketOptions), { port: 7000 }),
    Object.assign(Object.assign({}, DigitalProjection.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, DigitalProjection.baseSocketOptions), { port: 4999 }),
];
